import React from 'react';
import SEO from "../common/SEO";
import HeaderTwo from '../common/header/HeaderTwo';
import FooterTwo from '../common/footer/FooterTwo';
import Copyright from '../common/footer/Copyright';
import Separator from "../elements/separator/Separator";
import { useTranslation } from "react-i18next";


const CookiesPolicy = () => {
    const { t } = useTranslation('enterprise');
    return (
        <>
            <SEO title="" />
            <main className="page-wrapper">
                <HeaderTwo btnStyle="btn-small btn-icon" HeaderSTyle="header-transparent" />

                {/* Start Slider Area  */}
                <div className="slider-area slider-style-1 variation-default height-850 bg_image" style={{height:"400px"}} data-black-overlay="1" >
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="inner text-center">
                                    <h1 className="title display-one cust-title mt-5">{t('politiqueCookies.title')}</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Slider Area  */}

                <Separator />   
                {/* Start 1.  */}
                <div className="about-area about-style-4 pt-5 pb-5">
                    <div className="container">
                        <div className="row row--40 align-items-center pt-5 pb-5 lt-display">
                            <div className="col-lg-12 mt_md--40 mt_sm--40">
                                <div className="content">
                                    <div className="inner">
                                        <h3 className="title">{t('politiqueCookies.paragraphe1.title')}</h3>
                                            <p>{t('politiqueCookies.paragraphe1.content')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
                {/* End 1.  */}
                <Separator />
                {/* Start 2.  */}
                <div className="about-area about-style-4 pt-5 pb-5">
                    <div className="container">
                        <div className="row row--40 align-items-center pt-5 pb-5 lt-display">
                            <div className="col-lg-12 mt_md--40 mt_sm--40">
                                <div className="content">
                                    <div className="inner">
                                        <h3 className="title">{t('politiqueCookies.paragraphe2.title')}</h3>
                                        <p>{t('politiqueCookies.paragraphe2.content')}</p>
                                        <tr>
                                            <td>{t('politiqueCookies.paragraphe2.chartrow1Col1')}</td>
                                            <td><h5>{t('politiqueCookies.paragraphe2.chartrow1Col2')}</h5><p>{t('politiqueCookies.paragraphe2.chartrow2content')}</p></td>
                                        </tr>
                                        <tr>
                                            <td>{t('politiqueCookies.paragraphe2.chartrow3Col1')}</td>
                                            <td><h5>{t('politiqueCookies.paragraphe2.chartrow3Col2')}</h5><p>{t('politiqueCookies.paragraphe2.chartrow4content')}</p></td>
                                        </tr>
                                        <tr>
                                            <td>{t('politiqueCookies.paragraphe2.chartrow5Col1')}</td>
                                            <td><h5>{t('politiqueCookies.paragraphe2.chartrow5Col2')}</h5><p>{t('politiqueCookies.paragraphe2.chartrow6content')}</p></td>
                                        </tr>
                                        <tr>
                                            <td>{t('politiqueCookies.paragraphe2.chartrow7Col1')}</td>
                                            <td><h5>{t('politiqueCookies.paragraphe2.chartrow7Col2')}</h5><p>{t('politiqueCookies.paragraphe2.chartrow8content')}</p></td>
                                        </tr>
                                        <tr>
                                            <td>{t('politiqueCookies.paragraphe2.chartrow9Col1')}</td>
                                            <td><h5>{t('politiqueCookies.paragraphe2.chartrow9Col2')}</h5><p>{t('politiqueCookies.paragraphe2.chartrow10content')}</p></td>
                                        </tr>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
                {/* End 2.  */}
                <Separator />
                {/* Start 2.  */}
                <div className="about-area about-style-4 pt-5 pb-5">
                    <div className="container">
                        <div className="row row--40 align-items-center pt-5 pb-5 lt-display">
                            <div className="col-lg-12 mt_md--40 mt_sm--40">
                                <div className="content">
                                    <div className="inner">
                                        <h3 className="title">{t('politiqueCookies.paragraphe3.title')}</h3>
                                        <p>{t('politiqueCookies.paragraphe3.chartrow2content')}</p>
                                        <tr>
                                            <td>-</td>
                                            <td>
                                            <h5>{t('politiqueCookies.paragraphe3.chartrow1Col2')}</h5>
                                            <p style={{margin:"0px"}}>{t('politiqueCookies.paragraphe3.chartrow3Col2')}</p>
                                            <Separator />
                                            <p style={{margin:"0px"}}>{t('politiqueCookies.paragraphe3.chartrow4Col2')}</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>-</td>
                                            <td>
                                            <h5>{t('politiqueCookies.paragraphe3.chartrow5Col2')}</h5>
                                            <p>{t('politiqueCookies.paragraphe3.chartrow6content')}</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>-</td>
                                            <td>
                                            <h5>{t('politiqueCookies.paragraphe3.chartrow7Col2')}</h5>
                                            <p>{t('politiqueCookies.paragraphe3.chartrow8content')}</p>
                                            </td>
                                        </tr>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
                {/* End 2.  */}
                <Separator />

                <FooterTwo />
                <Copyright />
            </main>
        </>
    )
}

export default CookiesPolicy
